var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWineGlass = function SvgWineGlass(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M6.052 2.916C6.095 2.4 6.53 2 7.049 2h6c.518 0 .953.4.996.916l.438 5.262a4.45 4.45 0 0 1-3.434 4.706V16h1.5a.999.999 0 1 1 0 2h-5a.999.999 0 1 1 0-2h1.5v-3.113a4.45 4.45 0 0 1-3.435-4.706l.438-5.262zM7.802 6h4.493l-.165-2H7.967z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWineGlass);
export default ForwardRef;